export const specialCharacterRegex = /^[^#%$&½?@æ~!|*"`]*$/;
